import React from 'react';

import { SectionType } from '../../../../../dashboardSettingsTypes';

export function useSettingsRow(
  initialSection: SectionType,
  updateSection: CallableFunction,
) {
  const [section, setSection] = React.useState<SectionType>(initialSection);

  React.useEffect(() => {
    if (initialSection) setSection(initialSection);
  }, [initialSection]);

  function onDragEnd(result: any) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    setSection({
      ...section,
      components: reorderComponents(
        result.source.index,
        result.destination.index,
      )
    });
  }

  function reorderComponents(startIndex: number, endIndex: number) {
    const result = section.components.slice();
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    for (let index = 0; index < result.length; index++) {
      const element = result[index];
      element.order = index;
    }
    return result;
  }

  function updateSectionFlag(checked: boolean) {
    let newSection = { ...section, checked: checked };
    newSection.components.forEach(c => (c.checked = checked));
    setSection(newSection);
    updateSection(section.name, newSection);
  }

  function updateComponentFlag(componentName: string, checked: boolean) {
    const sectionComponents = section.components.slice();
    let component = sectionComponents.find(c => c.name === componentName);
    if (!component) return;
    component.checked = checked;
    const sectionChecked = sectionComponents.every(c => c.checked);

    setSection({
      ...section,
      checked: sectionChecked,
      components: sectionComponents,
    });
    updateSection(section.name, section);
  }

  return {
    section,
    updateSectionFlag,
    onDragEnd,
    updateComponentFlag,
  };
}
